import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dae66d0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }

import { onMounted, getCurrentInstance, computed, watch } from 'vue';
import { useStore } from 'vuex';
import * as Visualization from '@/carto-node/models/visualization';
import { getCartoModels } from '@/carto-node/models/CoreModels';

import SideMenu from '@/components/SideMenu.vue';
import SearchInput from '@/components/SearchInput.vue';
import NavigationBar from '@/components/NavigationBar/NavigationBar.vue';
import CesiumViewer from '@/components/CesiumViewer.vue';
import logo from '@/assets/images/app/logo.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();
const AUTO_SELECT_FIRST_MAP = process.env.VUE_APP_AUTO_SELECT_FIRST_MAP == 'true';
const firstMapLicenseSrc = computed(() => {
  const topMap = store.getters['maps/topVisibleMap']
  if (topMap && topMap.show_license) {
    return logo;
  }
  return '';
});
onMounted(() => {
  const instance = getCurrentInstance();
  const eb = instance?.appContext.config.globalProperties.$EventBus;
  eb.on('globalcheckedLayer', (layer) => {
    store.state.engineStore.engine?.addLayer({
      uid: layer.uid,
      url: layer.layerServiceInfo.url,
      type: 'TMS',
      options: {
        bounds: layer.bounds,
      },
    });
  });
  eb.on('globalcheckedWMTSLayer', (layer) => {
    store.state.engineStore.engine?.addLayer(layer);
  });

  eb.on('globaluncheckedLayer', (layer) => {
    store.state.engineStore.engine?.removeLayer(layer.uid);
  });
  eb.on('globalrefreshLayer', (layer) => {
    store.state.engineStore.engine?.refreshLayer({
      uid: layer.uid,
      url: layer.layerServiceInfo.url,
      type: 'TMS',
    });
  });
  eb.on('globalmoveLayer', (fromTo) => {
    const { from, to } = fromTo;
    store.state.engineStore.engine?.moveLayer(from, to);
  });
  eb.on('globalshowLayer', (index: number) => {
    store.state.engineStore.engine?.showLayer(index);
  });
  eb.on('globalhideLayer', (index: number) => {
    store.state.engineStore.engine?.hideLayer(index);
  });

  if (AUTO_SELECT_FIRST_MAP) {
    autoSelectFirstMap(eb);
  }
});

// 自动选中 MapGallery 中的第一张图
function autoSelectFirstMap(eb) {
  store.dispatch('maps/filter', { filter: 'allPublic', keyword: '' });

  const stop = watch(
    () => {
      const firstMap = Object.values(store.state.maps.list)[0] as any;
      return store.state.engineStore.engine && firstMap?.layers ? firstMap : null;
    },
    (firstMap) => {
      if (!firstMap) return;
      stop();
      if (firstMap.added_to_map) return;
      const earthLayer = Visualization.convert2EarthLayer(firstMap, getCartoModels(), {
        width: 600,
        height: 280,
      });
      if (!earthLayer.layerServiceInfo.url) return;
      store.dispatch('maps/addToEarth', firstMap.id);
      eb.emit('globalcheckedLayer', earthLayer);
    },
  );
}

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_header, { height: "50px" }, {
      default: _withCtx(() => [
        _createVNode(NavigationBar)
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(SideMenu),
        _createVNode(_component_el_main, { style: {"overflow":"hidden","position":"relative"} }, {
          default: _withCtx(() => [
            _createVNode(SearchInput),
            (firstMapLicenseSrc.value)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: firstMapLicenseSrc.value,
                  class: "lisence-img"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode(CesiumViewer)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})